import { render, staticRenderFns } from "./IDPhoto.vue?vue&type=template&id=daa6e900&scoped=true"
import script from "./IDPhoto.vue?vue&type=script&lang=js"
export * from "./IDPhoto.vue?vue&type=script&lang=js"
import style0 from "./IDPhoto.vue?vue&type=style&index=0&id=daa6e900&prod&lang=scss"
import style1 from "./IDPhoto.vue?vue&type=style&index=1&id=daa6e900&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daa6e900",
  null
  
)

export default component.exports